
export default {
  emits: ['mounted', 'before-unmount'],
  async mounted() {
    this.$emit('mounted', this.$el)
  },
  beforeUnmount() {
    this.$emit('before-unmount', this.$el)
  }
}
